import React from "react"
import Footer from "components/mainLayout/footer/Footer"
import TopBar from "components/mainLayout/topBar/TopBar"
import { Outlet } from "react-router-dom"
import "./PublicLayout.scss"
import "../publicShared.scss"
const PublicLayout = () => {
    return (
        <div className="publicLayout">
            <TopBar />
            <div className="container">
                <div className="page-wrapper">
                    <Outlet />
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default PublicLayout
